import { generateSearchQuery, parseSearchQuery } from '../../utils';
class QueryAPI {
    get params() {
        return parseSearchQuery(location.search);
    }
    get query() {
        return this.generateQuery(this.params);
    }
    getKey(key) {
        return this.params?.[key];
    }
    setKey(key, value) {
        this.set({
            ...this.params,
            [key]: value,
        });
    }
    delete(key) {
        this.set({
            ...this.params,
            [key]: null,
        });
    }
    set(params) {
        if (!params) {
            return;
        }
        const search = new URLSearchParams();
        Object.keys(params).forEach((key) => {
            if (params[key] === null) {
                return;
            }
            if (typeof params[key] === 'undefined') {
                return;
            }
            if (typeof params[key] === 'string' && !params[key]) {
                return;
            }
            search.append(key, `${params[key]}`);
        });
        if (search.size > 0) {
            this.replace(search);
        }
    }
    has(key) {
        return typeof this.params?.[key] !== 'undefined';
    }
    replace(params) {
        history.replaceState({}, '', `${window.location.origin}${window.location.pathname}${this.generateQuery(params)}`);
    }
    replacePath(path) {
        history.replaceState({}, '', `${window.location.origin}${path}`);
    }
    generateQuery(params = {}) {
        return generateSearchQuery(params);
    }
}
export const queryAPI = new QueryAPI();
